const TrashIcon = ({ width, height, color, className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width={width || 32}
      height={height || 32}
      className={"icon" + (className !== undefined ? " " + className : "")}
      viewBox="0 0 24 24"
      fill={color || "#00000"}
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7z" />
    </svg>
  );
};

export { TrashIcon }
